import { z as zod } from "zod";

export const PrivacySchema = zod.object({
    content: zod.string().min(1, "Der Inhalt darf nicht leer sein."),
});
